import React, { Component } from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import { Modal,Tabs, Tab } from 'react-bootstrap';
import {isEmpty, size} from 'lodash';

import { CheckBoxSingle } from '../../components/checkboxes/check-box-single';
import { Dropdown } from 'components/Dropdown/Dropdown';

import * as projectActionType from '../../Projects/constants';
import * as AuthActionType from '../../Auth/constants';

class UnassignUserFromProject extends Component {
  static propTypes = {
    isOpen: PropTypes.bool,
    closeModal: PropTypes.func,
    onSubmit: PropTypes.func,
    dispatch: PropTypes.func,
    modalName: PropTypes.string,
    errorMsg: PropTypes.array,
    userInfo: PropTypes.object,
    ProjectListByUserId: PropTypes.array,
    builderUserList: PropTypes.array,
    UserProfile: PropTypes.object
  }

  constructor(props) {
    super(props);

    this.state = {
      key: 'owner',
      projectCheckList: {},
      userSelected: null
    };
  }

  componentDidMount() {
    this.getProjectByUserId(true);
  }

  getProjectByUserId = (isOwner) => {
    const { userInfo, dispatch } = this.props;
    dispatch({
      type: projectActionType.GET_PROJECT_BY_USER_ID_ASYNC,
      params: {
        userId: userInfo.userId,
        isOwner
      }
    });
  }

  onSubmit = (e) => {
    e.preventDefault();
    const {userInfo} = this.props;
    const {userSelected, projectCheckList} = this.state;
    let projectIds = [];
    if (projectCheckList) {
      for (const key in projectCheckList) {
        if ({}.hasOwnProperty.call(projectCheckList, key)) {
          projectIds.push(key);
        }
      }
    }

    if (this.state.key === 'owner') {
      const params = {
        currentOwnerId: userInfo.userId,
        newOwnerId: userSelected.value,
        projectIds
      };
      this.props.dispatch({
        type: projectActionType.REASSIGN_PROJECT_OWNER_ASYNC,
        params,
        callback: this.props.closeModal
      });
    } else {
      const params = {
        currentOwnerId: userInfo.userId,
        newOwnerId: userSelected.value,
        projectIds
      };
      this.props.dispatch({
        type: projectActionType.REASSIGN_PROJECT_COORDINATOR_ASYNC,
        params,
        callback: this.props.closeModal
      });
    }
  }

  onSelectTab = (key) => {
    this.setState({
      key,
      projectCheckList: [],
      isSelectAllChecked: false
    });
    if (key === 'coordinator') {
      this.getProjectByUserId(false);
    } else {
      this.getProjectByUserId(true);
    }
  }

  onChecked = (projectId) => {
    let newCheckList = {...this.state.projectCheckList};
    const { ProjectListByUserId } = this.props;
    if (!this.state.projectCheckList[projectId]) {
      this.setState({
        projectCheckList: {
          ...this.state.projectCheckList,
          [projectId]: !this.state.projectCheckList[projectId]
        },
        isSelectAllChecked: (size(newCheckList) + 1) === ProjectListByUserId.length
      });
    } else {
      delete newCheckList[projectId];
      this.setState({
        projectCheckList: newCheckList,
        isSelectAllChecked: false
      });
    }
  }

  onSelectAllChecked = () => {
    const { ProjectListByUserId } = this.props;
    if (this.state.isSelectAllChecked) {
      this.setState({
        projectCheckList: {},
        isSelectAllChecked: false
      });
    } else {
      let newCheckList = {...this.state.projectCheckList};
      for (let i = 0; i < ProjectListByUserId.length; i++) {
        newCheckList[ProjectListByUserId[i].id] = true;
      }
      this.setState({
        projectCheckList: newCheckList,
        isSelectAllChecked: true
      });
    }
  }

  renderProjectList() {
    const { ProjectListByUserId } = this.props;
    if (ProjectListByUserId && ProjectListByUserId.length) {
      return (
        <div style={{ height: 300, overflow: 'auto'}}>
          <CheckBoxSingle
            checked={this.state.isSelectAllChecked}
            ref={c => { this.check = c; }}
            name='checkToUnassign'
            className='checkbox-default'
            onChecked={this.onSelectAllChecked}
            style={{marginTop: -7}}
            label='Select all'
            labelStyle={{fontWeight: 600}}
          />
          {
            ProjectListByUserId.map((project, index) => {
              return (
                <div key={`project-${index}`}>
                  <CheckBoxSingle
                    checked={this.state.projectCheckList[project.id] !== null && this.state.projectCheckList[project.id] === true}
                    ref={c => { this.check = c; }}
                    name='checkToUnassign'
                    className='checkbox-default'
                    onChecked={() => this.onChecked(project.id)}
                    style={{marginTop: -7}}
                    label={project.name}
                  />
                </div>
              );
            })
          }
        </div>
      );
    }

    return <div style={{ height: 300, overflow: 'auto'}} />;
  }

  onShowPopUpSelectUser = () => {
    this.setState({ isShowPopupSelectUser: true });
  }

  onHidePopUpSelectUser = () => {
    this.setState({ isShowPopupSelectUser: false });
  }

  onSelectChange = (event, name) => {
    this.setState({
      [name]: event.value
    });
  }

  onFetchUser = () => {
    const {userInfo} = this.props;
    this.setState({isLoadingUser: true});
    this.props.dispatch({
      type: AuthActionType.SELECT_LISTS_BUILDER_USER_ASYNC,
      params: {
        searchKey: '',
        selectedValue: ''
      },
      payload: {
        ExcludeUserId: userInfo.userId
      },
      callback: () => this.setState({isLoadingUser: false})
    });
  }

  renderPopupSelectUser = () => {
    const { builderUserList } = this.props;
    return (
      <div className='arrow_box_fade' style={{position: 'fixed', top: 0, bottom: 0, left: 0, right: 0}}>
        <div className='arrow_box' style={{ position: 'absolute', bottom: 65, left: 120, width: 350, padding: 10, border: '1px solid #c3c3c3', backgroundColor: 'white', paddingLeft: 20 }}>
          <p style={{fontSize: 14}}>Select a user to take on  these projects. All open responsibilities (requests for service, work orders) won't be reassigned.</p>

          {this.props.UserProfile.sso
            ? <Dropdown
              onChange={ref => { this.onSelectChange(ref, 'userSelected'); }}
              filter={true}
              className='filestring-dropdown filter-dropdown'
              onRemote={this.onFetchUser}
              options={builderUserList}
              loading={this.state.isLoadingUser}
              optionLabel='text'
              value={this.state.userSelected}
              name='user'
              groupLabels={[
                {
                  label: 'System users',
                  field: 'sso',
                  condition: [true]
                },
                {
                  label: 'Builder users',
                  field: 'sso',
                  condition: [false, null]
                }
              ]}
              placeholder='-- Please select'
              style={{ width: '100%', paddingRight: 10, margin: 0 }}
            />
            : <Dropdown
              onChange={ref => { this.onSelectChange(ref, 'userSelected'); }}
              filter={true}
              className='filestring-dropdown filter-dropdown'
              onRemote={this.onFetchUser}
              options={builderUserList}
              loading={this.state.isLoadingUser}
              optionLabel='text'
              value={this.state.userSelected}
              name='user'
              placeholder='-- Please select'
              style={{ width: '100%', paddingRight: 10, margin: 0 }}
            />
          }

          <button
            className='btn btn-primary margin-top-10 btn-siteone-default'
            onClick={this.onHidePopUpSelectUser}>Cancel</button>
          <button
            className='btn btn-siteone btn-siteone-danger margin-top-10'
            disabled={!this.state.userSelected}
            onClick={this.onSubmit}
            style={{marginLeft: 10}}>Save & Unassign</button>

        </div>
      </div>
    );
  }

  render() {
    const { userInfo } = this.props;
    const {projectCheckList} = this.state;
    return (
      <Modal
        show={this.props.isOpen}
        size='lg'
        dialogClassName='custom-modal'
        backdrop='static'
        container={this}
        id='rename-modal'
      >
        <Modal.Header>
          <Modal.Title id='contained-modal-title-lg'>Unassign {userInfo.fullName} from projects</Modal.Title>
        </Modal.Header>
        <Modal.Body>
          <Tabs
            id='controlled-tab-example'
            activeKey={this.state.key}
            onSelect={this.onSelectTab}
          >
            <Tab eventKey='owner' title='As owner'>
              {this.renderProjectList()}
            </Tab>
            <Tab eventKey='coordinator' title='As normal coordinator'>
              {this.renderProjectList()}
            </Tab>
          </Tabs>
          <div className='col-12 margin-top-5' style={{ display: 'flex', flexDirection: 'row' }}>
            <div>
              <button className='btn btn-primary margin-right-5 btn-siteone-default' onClick={this.props.closeModal}>Cancel</button>
            </div>

            <div style={{ position: 'relative' }}>
              <button className='btn btn-siteone btn-siteone-danger margin-left-10' disabled={isEmpty(projectCheckList)} onClick={this.onShowPopUpSelectUser}>Unassign</button>
              {this.state.isShowPopupSelectUser && this.renderPopupSelectUser()}
            </div>

          </div>
        </Modal.Body>

      </Modal>
    );
  }
}

const mapStateToProps = (state) => {
  return {
    ProjectListByUserId: state.ProjectStore.ProjectListByUserId,
    builderUserList: state.authReducer.builderUserList,
    UserProfile: state.UserStore.UserProfile
  };
};

export default connect(mapStateToProps)(UnassignUserFromProject);



// WEBPACK FOOTER //
// ./src/User/Components/unassign-user-from-project.js